export class AppConsts {
    static readonly DefaultTitle = 'UPM - SmartInvoicing';
    static readonly SmartInvoicing = 'SmartInvoicing';
    static readonly Hyphen = '-';
    static readonly RefreshTabsEvent = 'refreshTabs';
    static readonly LocalStorageKey = 'storage';
    static readonly GdprNavigationMenuItemName = 'Gdpr.GdprNavigation';
    static readonly ChangeCurrentVendorMenuItemName = 'change-current-place';
    static readonly GrafanaConfigurationName = 'grafana';
    static readonly AppName = 'SmartInvoicing';
    static readonly MaxPageSize = 1000;
    static readonly DatePickerFormat = 'dd/mm/yy';
    static readonly DateFormat = 'dd/MM/yyyy';
    static readonly DateTimeFormat = 'dd/MM/yyyy HH:mm';
    static readonly DateTimeCompleteFormat = 'dd/MM/yyyy HH:mm:ss.SSS';
    static readonly PurchaseOrderNumberLength = 10;
    static readonly TenantKey = 'SmartInvoicingTenant';
    static readonly MinAutocompleteCharsToSearch = 3;
    static readonly DecimalPrecision = 3;
}